import axiosClient from './axiosClient';
import toast from 'react-hot-toast';

export const wordDocApi = {
  exportTaskWord: async (taskId: string, filename: string): Promise<void> => {
    const res = await axiosClient.get(`/tasks/${taskId}/export-word`, {
      responseType: 'blob',
    });
    const blob = new Blob([res.data], { type: 'application/msword' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    toast.success('Task exported successfully');
  },

  exportSubtaskWord: async (subtaskId: string, filename: string): Promise<void> => {
    const res = await axiosClient.get(`/subtasks/${subtaskId}/export-word`, {
      responseType: 'blob',
    });
    const blob = new Blob([res.data], { type: 'application/msword' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    toast.success('Subtask exported successfully');
  },
};


